// extracted by mini-css-extract-plugin
export default {"main":"Audit_main__hutta","cover":"Audit_cover__gcCvZ","flex_col":"Audit_flex_col__LyWF7"};